// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  scorecardId: __t.u64().primaryKey().name("scorecard_id"),
  recipeId: __t.u64().name("recipe_id"),
  workspaceId: __t.option(__t.u64()).name("workspace_id"),
  taskTag: __t.string().name("task_tag"),
  receiptCount: __t.u32().name("receipt_count"),
  avgCostMicros: __t.i64().name("avg_cost_micros"),
  avgLatencyMs: __t.u32().name("avg_latency_ms"),
  acceptanceRate: __t.f32().name("acceptance_rate"),
  correctionRate: __t.f32().name("correction_rate"),
  ciPassRate: __t.f32().name("ci_pass_rate"),
  watcherQuietness: __t.f32().name("watcher_quietness"),
  lastUpdatedAt: __t.i64().name("last_updated_at"),
});
